module.exports = __webpack_public_path__ + "img/Jhakaas.98c1f175.png";